var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 12C47.1046 12 48 12.8954 48 14V14.8C48 15.9046 47.1046 16.8 46 16.8H2C0.895432 16.8 0 15.9046 0 14.8V14C0 12.8954 0.895431 12 2 12H46ZM46 21.6C47.1046 21.6 48 22.4954 48 23.6V24.4C48 25.5046 47.1046 26.4 46 26.4H2C0.895432 26.4 0 25.5046 0 24.4V23.6C0 22.4954 0.895431 21.6 2 21.6H46ZM46 31.2C47.1046 31.2 48 32.0954 48 33.2V34C48 35.1046 47.1046 36 46 36H2C0.895432 36 0 35.1046 0 34V33.2C0 32.0954 0.895431 31.2 2 31.2H46Z"
  })));
};
export default SvgHamburger;